<template>
  <div style="padding: 20px;background-color: #ffffff;">
    <div class="">
      <div @keyup.enter.stop="getPage({pageNum: 1})">
        <el-select v-model="queryParam.batchId" @change="getSpecialtyList" placeholder="选择考试" filterable style="width:200px;margin-right:10px;">
          <el-option v-for="(item,index) in batchList" :key="index" :label="item.batchName" :value="item.batchId" :class="item.disabled?'none':''"></el-option>
        </el-select>
        <el-date-picker v-model="signTime" type="daterange" range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期"
                        :default-time="['00:00:00','23:59:00']" style="width:410px;margin-right:10px;margin-bottom: 10px;"></el-date-picker>
        <el-button @click="getPage({pageNum: 1})" type="primary">搜索</el-button>
        <el-button @click="queryParam=JSON.parse(JSON.stringify(oldQueryParam))" type="default">重置</el-button>
      </div>
    </div>
    <div ref="page" style="margin-top: 12px;">
      <el-table :data="page.list" stripe :height="tableHeight" size="medium" @selection-change="multipleSelection=$event">
        <el-table-column prop="addTime" label="创建时间"></el-table-column>
        <el-table-column prop="agentName" label="所属考级点"></el-table-column>
        <el-table-column prop="batchName" label="考试名称"></el-table-column>
        <el-table-column prop="startTime" label="结算开始时间"></el-table-column>
        <el-table-column prop="endTime" label="结算结束时间"></el-table-column>
        <el-table-column prop="refundStartTime" label="退款结算开始时间"></el-table-column>
        <el-table-column prop="refundEndTime" label="退款结算结束时间"></el-table-column>
        <el-table-column prop="auditStatus" label="结算状态">
          <template slot-scope="scope">
            {{$enums.settleAuditStatus[scope.row.auditStatus]}}
          </template>
        </el-table-column>
        <el-table-column label="操作" width="200">
          <template slot-scope="scope">
            <el-button size="mini" type="text" @click="edit(scope.row)">查看详情</el-button>
            <el-button v-if="scope.row.auditStatus == 1 || scope.row.auditStatus == 2" size="mini" type="text"
                       @click="$router.push({path:'/workflow/checkincome',query:{settleId:scope.row.settleId, batchId:scope.row.batchId}})">查看订单
            </el-button>
            <el-button v-if="scope.row.auditStatus == 1" size="mini" type="text" style="color: #E91212;" @click="cancel(scope.row)">确认结算</el-button>
          </template>
        </el-table-column>
      </el-table>
      <div style="margin-top: 20px;">
        <el-pagination class="text-center" background
                       :page-sizes="[20, 50, 100, 200]" layout="total, sizes, prev, pager, next, jumper"
                       :total="page.total" :page-size="page.pageSize" :current-page="page.pageNum"
                       @current-change="getPage({pageNum:$event})" @size-change="getPage({pageNum:1,pageSize:$event})"></el-pagination>
      </div>
    </div>
    <el-dialog title="查看订单详情" v-if="editForm.show" :visible.sync="editForm.show" width="800px"
               :close-on-press-escape="false" :close-on-click-modal="false" :destroy-on-close="true">
      <Edit :row="editForm.row" @close="getPage()" style="max-height: 500px;overflow-y: auto;"></Edit>
    </el-dialog>
  </div>
</template>
<script>
import Edit from './income-deit'

export default {
  name: 'income',
  components: { Edit },
  props: [],
  data () {
    return {
      tableHeight: 200,
      queryParam: { batchId: this.$route.query.batchId },
      oldQueryParam: {},
      page: { pageSize: 20, pageNum: 1 },
      multipleSelection: [],
      editForm: { show: false, row: null },
      batchList: [],
      specialtyList: [],
      signTime: []
    }
  },
  async created () {
    this.batchList = await this.$HTTP.ApiBatch.getList({ batchStatus: [2, 3] })
    if (this.Tool.isNull(this.batchList)) {
      throw new Error('没有考试数据')
    }
    if (!this.queryParam.batchId) {
      this.queryParam.batchId = this.batchList[0].batchId
    }
    await this.getSpecialtyList()
    this.oldQueryParam = JSON.parse(JSON.stringify(this.queryParam))
  },
  async mounted () {
    this.Tool.windowResizeEvent(() => {
      this.tableHeight = this.Tool.calcTableHeight(this.$refs['page'])
    })
  },
  async beforeDestroy () {
  },
  computed: {},
  watch: {},
  methods: {
    async getSpecialtyList (event) {
      this.specialtyList = await this.$HTTP.ApiSpecialty.getList({ batchId: this.queryParam.batchId })
      if (event) {
        this.queryParam.specialtyId = ''
      }
      await this.getPage()
    },
    async getPage (queryParam) {
      try {
        this.queryParam.startTime = ''
        this.queryParam.endTime = ''
        this.editForm.show = false
        this.editForm.row = null
        this.queryParam = Object.assign({}, this.queryParam, queryParam)
        if (this.signTime) {
          this.$set(this.queryParam, 'startTime', this.signTime[0])
          this.$set(this.queryParam, 'endTime', this.signTime[1])
        }
        let page = await this.$HTTP.ApiSettle.getSettlePage(this.queryParam)
        this.page = page
        this.$nextTick(() => {
          let wrapper = window.document.getElementsByClassName('el-table__body-wrapper')
          if (wrapper) {
            wrapper[0].scrollTop = 0
          }
        })
      } catch (e) {
        this.Tool.doError(e)
      }
    },
    async edit (row) {
      this.editForm.show = true
      if (row) {
        this.editForm.row = row
      } else {
        this.editForm.row = null
      }
    },
    async cancel (row) {
      try {
        let confirm = await this.$confirm('确定结算订单吗？', '提示', { type: 'warning' })
        if (confirm === 'confirm') {
          console.log(row.settleId)
          await this.$HTTP.ApiSettle.getSettleConfirm(row.settleId)
          await this.getPage()
        }
      } catch (e) {
        this.Tool.doError(e)
      }
    },
    async exportExcel (row) {
      try {
        await this.$HTTP.ApiExamOnline.exportExcel(this.queryParam)
        this.getTaskInfo('export_enroll_exam_list')
      } catch (e) {
        this.Tool.doError(e)
      }
    },
    getTaskInfo (taskName) {
      this.taskInterval = setInterval(async () => {
        try {
          let taskInfo = await this.$HTTP.ApiExamImport.getTaskInfo(taskName)
          console.log(taskInfo)
          if (taskInfo) {
            if (taskInfo.errorExcelUrl) {
              clearInterval(this.taskInterval)
              let fileUrl = await this.$HTTP.ApiOss.signatureUrl(taskInfo.errorExcelUrl, 'temp')
              this.Tool.downloadFile(fileUrl)
              await this.getPage()
            } else if (taskInfo.successExcelUrl) {
              clearInterval(this.taskInterval)
              let fileUrl = await this.$HTTP.ApiOss.signatureUrl(taskInfo.successExcelUrl, 'temp')
              this.Tool.downloadFile(fileUrl)
              await this.getPage()
            } else if (taskInfo.percent >= 100) {
              clearInterval(this.taskInterval)
              this.$message({ type: 'success', message: '操作成功' })
              await this.getPage()
            } else if (taskInfo.status >= 2) {
              clearInterval(this.taskInterval)
              if (taskInfo.errMsg) {
                this.$message({ type: 'error', message: taskInfo.errMsg })
              }
              await this.getPage()
            }
          } else {
            clearInterval(this.taskInterval)
          }
        } catch (e) {
          clearInterval(this.taskInterval)
        }
      }, 2000)
    }
  }
}
</script>
